import angular from 'angular';
import SettingsService from './settings.service';

let settingsModule = angular.module('settingsService', [
])
.service('SettingsService', SettingsService);

export default settingsModule;



// WEBPACK FOOTER //
// ./client/common/services/settings/settings.js